<template>
    <div class="space-y-2">
        <div>
            <div class="flex items-center justify-between">
                <div>
                    <div class="text-xs font-bold text-gray-500 uppercase">
                        {{ localWeeklyHours.dayOfWeek }}
                    </div>
                    <div
                        v-if="localWeeklyHours.timeRanges.length === 0"
                        class="text-sm text-gray-400"
                    >
                        No availability
                    </div>
                </div>
                <div v-if="localWeeklyHours.timeRanges.length === 0">
                    <Button
                        type="button"
                        iconName="plus"
                        color="light"
                        @click="handleAddTimeRange()"
                    />
                </div>
            </div>
            <div
                v-if="localWeeklyHours.timeRanges.length > 0"
                class="space-y-1"
            >
                <input
                    type="hidden"
                    :name="`${RequestBodyKeyEnum.App_Availability_WeekhlyHours}[${index}][${RequestBodyKeyEnum.App_Availability_WeekhlyHour_DayOfWeek}]`"
                    :value="weeklyHours.dayOfWeek"
                    required
                />
                <div
                    v-for="(
                        timeRange, timeRangeIndex
                    ) in localWeeklyHours.timeRanges"
                    :key="timeRange.id"
                >
                    <div
                        class="flex flex-col md:flex-row items-end md:items-center gap-1"
                    >
                        <TextInput
                            type="time"
                            step="300"
                            :name="`${RequestBodyKeyEnum.App_Availability_WeekhlyHours}[${index}][${RequestBodyKeyEnum.App_Availability_WeekhlyHour_TimeRanges}][${timeRangeIndex}][${RequestBodyKeyEnum.App_Availability_WeekhlyHour_TimeRange_StartAt}]`"
                            v-model="timeRange.start"
                            required
                        />
                        <TextInput
                            type="time"
                            step="300"
                            :name="`${RequestBodyKeyEnum.App_Availability_WeekhlyHours}[${index}][${RequestBodyKeyEnum.App_Availability_WeekhlyHour_TimeRanges}][${timeRangeIndex}][${RequestBodyKeyEnum.App_Availability_WeekhlyHour_TimeRange_EndAt}]`"
                            v-model="timeRange.end"
                            required
                        />
                        <div class="flex items-center gap-1">
                            <Button
                                type="button"
                                iconName="trash"
                                color="danger-outline"
                                @click="handleRemoveTimeRange(timeRange.id)"
                            />
                            <Button
                                type="button"
                                iconName="plus"
                                color="light"
                                @click="handleAddTimeRange()"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ref, type PropType } from 'vue'
    import TextInput from '@/Shared/Component/Forms/TextInput.vue'
    import {
        type TimeRangeType,
        type WeeklyHoursType,
    } from '@/Shared/AutoGenerated/Main'
    import Button from '@/Shared/Component/Button.vue'
    import useId from '@/Shared/Hook/useId'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'

    const props = defineProps({
        weeklyHours: {
            type: Object as PropType<WeeklyHoursType>,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
    })

    const localWeeklyHours = ref<WeeklyHoursType>(props.weeklyHours)

    const handleAddTimeRange = (): void => {
        localWeeklyHours.value = {
            id: localWeeklyHours.value.id,
            dayOfWeek: localWeeklyHours.value.dayOfWeek,
            timeRanges: [
                ...localWeeklyHours.value.timeRanges,
                {
                    id: useId().make(),
                    start: '09:00',
                    end: '17:00',
                },
            ],
        }
    }

    const handleRemoveTimeRange = (id: string): void => {
        localWeeklyHours.value = {
            id: localWeeklyHours.value.id,
            dayOfWeek: localWeeklyHours.value.dayOfWeek,
            timeRanges: localWeeklyHours.value.timeRanges.filter(
                (timeRange: TimeRangeType) => timeRange.id !== id,
            ),
        }
    }
</script>
